import React, { useEffect, useState } from 'react';
import Swiper from 'swiper';
import python from '../../public/images/Technologies/python.png'
import nodejs from '../../public/images/Technologies/nodejs.png'
import Angular from '../../public/images/Technologies/angular.png'
import java from '../../public/images/Technologies/java.png'
import react from '../../public/images/Technologies/reactjs.png'
import mongodb from '../../public/images/Technologies/mongobd.png'
import mysql from '../../public/images/Technologies/mysql.png'
import springboot from '../../public/images/Technologies/springboot.png'
import wp from '../../public/images/Technologies/wp.png'
import php from '../../public/images/Technologies/php.png'

const Brand = () => {
    const [slider, setSlider] = useState(null);
    useEffect(() => {
        if (!slider) {
            const brandSlider = new Swiper('#brandSlider1', {
                breakpoints: {
                    0: { slidesPerView: 7 },
                    576: { slidesPerView: 5 },
                    768: { slidesPerView: 5 },
                    992: { slidesPerView: 5 },
                    1200: { slidesPerView: 5 },
                    1400: { slidesPerView: 6 },
                },
                loop: true, // Enable continuous loop
            });
            setSlider(brandSlider);
        }
    }, [slider]);

    useEffect(() => {
        const slideNextWithDelay = () => {
            if (slider) {
                setTimeout(() => {
                    slider.slideNext();
                    slideNextWithDelay();
                }, 3000);
            }
        };

        slideNextWithDelay();

        return () => clearTimeout();
    }, [slider]);

    return (
      <div className='mb-4'>
      <h3 className='text-center mt-5'>Technologies we use</h3>
        <div className="brand-area py-5 mt-1">
            <div className="container th-container">
                <div className="swiper th-slider" id="brandSlider1">
                    <div className="swiper-wrapper">
                        <div className="swiper-slide">
                            <div className="brand-box">
                                <img src={python} alt="Brand Logo" height={50} width={100} />
                            </div>
                        </div>
                        <div className="swiper-slide">
                            <div className="brand-box">
                                <img src={nodejs} alt="Brand Logo" height={50} width={100}/>
                            </div>
                        </div>
                        <div className="swiper-slide">
                            <div className="brand-box">
                                <img src={wp} alt="Brand Logo"  height={50} width={100} />
                            </div>
                        </div>
                        <div className="swiper-slide">
                            <div className="brand-box">
                                <img src={php} alt="Brand Logo"  height={50} width={100} />
                            </div>
                        </div>
                        <div className="swiper-slide">
                            <div className="brand-box">
                                <img src={react} alt="Brand Logo"  height={50} width={100} />
                            </div>
                        </div>
                        <div className="swiper-slide">
                            <div className="brand-box">
                                <img src={Angular} alt="Brand Logo"  height={50} width={100} />
                            </div>
                        </div>
                        <div className="swiper-slide">
                            <div className="brand-box">
                                <img src={java} alt="Brand Logo"  height={50} width={100} />
                            </div>
                        </div>
                        <div className="swiper-slide">
                            <div className="brand-box">
                                <img src={mongodb} alt="Brand Logo"  height={50} width={100} />
                            </div>
                        </div>
                        <div className="swiper-slide">
                            <div className="brand-box">
                                <img src={springboot} alt="Brand Logo"  height={50} width={100} />
                            </div>
                        </div>
                        <div className="swiper-slide">
                            <div className="brand-box">
                                <img src={mysql} alt="Brand Logo"   height={50} width={100}/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      </div>
    );
};

export default Brand;

